import { action } from '@ember/object';
import { service } from '@ember/service';
import Component from '@glimmer/component';

export default class BackOfANapkinTemplatesCustomComponent extends Component {
  @service organisation;
  @service intl;

  @action
  handleValueChange(e) {
    const calculation = this.args.calculation;
    calculation.value = isNaN(e.target.value) ? 0 : +e.target.value;
    this.args.onValueEmit(calculation);
  }

  @action
  handleDescriptionChange(e) {
    const calculation = { ...this.args.calculation };
    calculation.description = e.target.value;
    this.args.onValueEmit(calculation);
  }

  @action
  onConfidenceChange(confidence) {
    const calculation = { ...this.args.calculation };
    calculation.confidence_value = confidence.value;
    calculation.confidence_label = confidence.label;
    this.args.onValueEmit(calculation);
  }

  calculateValue(value = 0, confidence_multiplier = 0) {
    return (+value || 0) * (+confidence_multiplier || 0);
  }

  get confidenceLabel() {
    return this.args.calculation.confidence_label ?? '-';
  }

  get finalValue() {
    if (
      this.args.calculation?.value === undefined ||
      this.args.calculation?.confidence_value === undefined
    )
      return '-';
    return (
      +this.args.calculation.value * +this.args.calculation.confidence_value
    );
  }

  get isDisabled() {
    return !this.args.editMode;
  }
}
